import cancelRegisterReducer from './cancelRegisterReducer';
export default cancelRegisterReducer;